import { IUser, UserRole } from "engine/store/auth/types";

export const canAccessTags = (user: IUser | null): boolean => {
  if (!user) return false;
  return user.role === "admin";
};

export const canAccessUsers = (user: IUser | null): boolean => {
  if (!user) return false;
  return user.role === "admin";
};

export const canAccessOrganisations = (user: IUser | null): boolean => {
  if (!user) return false;
  return user.role === "admin";
};

export const canAccessAllArticles = (user: IUser | null): boolean => {
  if (!user) return false;
  return user.role === "admin" || user.role === "translator";
};

export const canEditArticleDetails = (user: IUser | null): boolean => {
  if (!user) return false;
  return user.role === "admin" || user.role === "author";
};

export const canDeleteArticle = (user: IUser | null): boolean => {
  if (!user) return false;
  return user.role === "admin";
};

export const canAccessArticle = (user: IUser | null, articleOrganisation?: string): boolean => {
  if (!user) return false;
  
  // Admin and translator can access all articles
  if (user.role === "admin" || user.role === "translator") {
    return true;
  }
  
  // Author can only access articles from their organisation
  if (user.role === "author") {
    return user.organisation === articleOrganisation;
  }
  
  return false;
};

export const getAvailableLanguages = (user: IUser | null): string[] => {
  if (!user) return [];
  
  // Admin can access all languages
  if (user.role === "admin" || user.role === "author") {
    return ["en", "ar", "fr", "ta", "ti", "tr", "uk", "fa", "ru", "es", "mn", "fil", "pt"];
  }
  
  // Translator can only access their specific languages + English (read-only)
  if (user.role === "translator") {
    return ["en", ...(user.languages || [])];
  }
  
  return [];
};

export const canEditLanguage = (user: IUser | null, language: string): boolean => {
  if (!user) return false;
  
  // Admin and author can edit all languages
  if (user.role === "admin" || user.role === "author") {
    return true;
  }
  
  // Translator cannot edit English (source only)
  if (user.role === "translator") {
    if (language === "en") return false;
    return user.languages?.includes(language) || false;
  }
  
  return false;
};

export const isAdmin = (user: IUser | null): boolean => {
  return user?.role === "admin";
};

export const isTranslator = (user: IUser | null): boolean => {
  return user?.role === "translator";
};

export const isAuthor = (user: IUser | null): boolean => {
  return user?.role === "author";
};

// Workflow permissions
export const canValidateArticle = (user: IUser | null): boolean => {
  // Only admin can validate/publish articles
  return user?.role === "admin";
};

export const canSubmitForValidation = (user: IUser | null): boolean => {
  // Admin and author can submit for validation
  return user?.role === "admin" || user?.role === "author";
};

export const canAccessAutoTranslate = (user: IUser | null): boolean => {
  // Only admin can enable auto-translate
  return user?.role === "admin";
};

export const canTranslateArticle = (user: IUser | null, articleStatus?: string): boolean => {
  if (!user) return false;
  
  // Translators can only translate published
  if (user.role === "translator") {
    return articleStatus === "published";
  }
  
  // Admin and author can translate anytime
  return user.role === "admin" || user.role === "author";
};

